export default {
  label: 'Origin',
  items: {
    listening: 'Social Listening',
    sac: 'Proprietary Metrics',
    smartCare: 'Smart Care',
    competitive: 'Competitive',
  },
};
